export default "__VITE_ASSET__CUufSbvd__"